import { useDispatch } from "react-redux";
import { getToken } from "../../utils/pip";
import { initChatSocket } from "../../redux/features/chat/chatSocketHandlers";
import { createSocketConnection } from "../../redux/features/chat/socket";
import { useEffect } from "react";

export const SocketBootstrap = ({ role }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = getToken(role);
    if (!token) return;

    createSocketConnection(token);
    initChatSocket(dispatch);
  }, [dispatch, role]);

  return null;
};
